/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */
import { Controller } from 'react-hook-form';
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import React, { useMemo, useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSnackbar } from 'notistack';
import CustomSelect from '../../../../components/form/CustomSelect';
import { Rules } from '../../../../helpers/RHFRules';
import CustomInput from '../../../../components/form/CustomInput';
import EditFirmayaServiceModify from './EditFirmayaServiceModify';
import WarningIcon from '../../../../components/IconsLibrary/WarningIcon';
import SuccesfullIcon from '../../../../components/IconsLibrary/SuccesfullIcon';
import AlertConfirm from '../../../../components/crosscutting/confirmationWindows/AlertConfirm';
import NumberFormatCustom from '../../../../components/form/NumberFormatCustom';
import { isAfterEndDate } from '../../../../helpers/generalUtils';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

/**
 * Set dinamic styles for Dialog
 * @param {*} theme mui material theme
 * @param {*} firstImageIcon First icon
 * @param {*} minWidth Dialog width
 * @param {*} minHeight Dialog Heigth
 * @param {*} marginTopImage margon of first Image
 * @param {*} minWidthButtonAcept width accept button
 * @returns a object with dinamic styles
 */
const alertStyles = (
  theme,
  firstImageIcon,
  minWidth,
  minHeight,
  marginTopImage,
  minWidthButtonAcept,
  paddingBottom = 15,
) => ({
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom,
  },
  dialogStyle: { minWidth, minHeight },
  firstImage: firstImageIcon,
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  styleTitle: {
    fontFamily: 'Mulish, sans-serif',
    fontSize: '20px',
    fontWeight: 700,
    marginTop: '-25px',
  },
  styleButtonAcept: {
    backgroundColor: '#FFFFFF',
    color: theme?.backOffice?.contracts?.btnSteps?.backgroundColor,
    border: `1px solid ${theme?.backOffice?.contracts?.btnSteps?.backgroundColor}`,
    minWidth: minWidthButtonAcept,
  },
});

const FirmayaServicesEdit = (props) => {
  const {
    productType,
    listValidityTypeContracts,
    transformedListMaxValidityAmountContracts,
    setValueProducts,
    getValuesProducts,
    resetProduct,
    clearErrorsProducts,
    controlProducts,
    errorsProducts,
    handleSubmitProducts,
    theme,
    classes,
    lastValidValueQuantityProducts,
    setLastValidValueQuantityProducts,
    isEditing,
    setIsEditing,
    servicesToAdd,
    setServicesToAdd,
    selectedIndex,
    setSelectedIndex,
    isSwitchEnabled,
    handleSwitchChange,
    setIsSwitchEnabled,
    formatNumberWithCommas,
    messageStyle,
    formData,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [productToEdit, setProductToEdit] = useState({});
  const [alertInfo, setAlertInfo] = useState({});
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [canSeeErrors, setCanSeeErrors] = useState(true);
  const dialogColorIcon = theme?.miplan?.buttonCard?.backgroundColor;
  const succesfullColor = theme?.miplan?.hoverButtonCard?.backgroundColor;

  const OwnSuccesfullIcon = useMemo(() => (
    <SuccesfullIcon color={succesfullColor} />
  ), [succesfullColor]);

  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);

  const setProductType = (event) => {
    setCanSeeErrors(true);
    const { value } = event.target;
    if (event.target.name === 'productService') {
      setValueProducts('productService', value);
    }
    return value;
  };

  const setValidityType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'validityService') {
      setValueProducts('validityService', value);
      setValueProducts('validityAmount', '');
    }
    return value;
  };

  const handleAgregarProducto = (data) => {
    if (isAfterEndDate(getValuesProducts('validityService'), getValuesProducts('validityAmount'), formData?.startDate, formData?.endDate)) {
      setAlertInfo({
        tituloModal: 'Vigencia de la bolsa',
        textButtonAcept: 'Aceptar',
        handleAccept: () => setIsAlertOpen(false),
        messageAlert: messageStyle(theme, OwnWarningIcon, 40, '508px', '200px'),
        showClose: false,
        isOnlyMessage: false,
        mensajeModal: 'Ten en cuenta que la vigencia de la bolsa debe ser menor o igual a la fecha de finalización del contrato.',
      });
      setIsAlertOpen(true);
      return;
    }
    const { productService, licenseId } = data;
    if (licenseId == null) {
      const alreadyAdded = servicesToAdd.some(
        (item) => item.licenseId == null
        && item.productService === productService,
      );

      if (alreadyAdded) {
        enqueueSnackbar('Ya existe el producto en la lista.', {
          variant: 'warning',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        });
        return;
      }
    }
    if (isEditing) {
      if (data.isSwitchEnabled) {
        data.quantityToAddService = '';
      }

      setServicesToAdd((prevServices) => prevServices.map(
        (service, index) => (index === selectedIndex ? { ...service, ...data } : service),
      ));
    } else {
      setServicesToAdd((prevServices) => [...prevServices, data]);
    }
    setValueProducts('productService', '');
    setValueProducts('quantityToAddService', '');
    setValueProducts('validityService', '');
    setValueProducts('validityAmount', '');
    setValueProducts('isSwitchEnabled', false);
    setIsSwitchEnabled(false);
    setIsEditing(false);
    setCanSeeErrors(false);
    setSelectedIndex(null);
    resetProduct();
  };

  const handleEditProduct = (index) => {
    const product = servicesToAdd[index];
    setProductToEdit(product);
    setIsEditing(true);
    setSelectedIndex(index);
    clearErrorsProducts();
  };

  const deleteProduct = (index) => {
    setIsAlertOpen(false);
    setTimeout(() => {
      setValueProducts('productService', '');
      setValueProducts('quantityToAddService', '');
      setValueProducts('validityService', '');
      setValueProducts('validityAmount', '');
      setValueProducts('isSwitchEnabled', false);
      setIsSwitchEnabled(false);
      setIsEditing(false);
      setSelectedIndex(null);
      resetProduct();
      setServicesToAdd((prevServices) => prevServices.filter((_, i) => i !== index));
      setAlertInfo({
        tituloModal: '¡Servicio eliminado!',
        showClose: false,
        isOnlyMessage: true,
        messageAlert: alertStyles(theme, OwnSuccesfullIcon, '508px', '284px', 65),
      });
      setIsAlertOpen(true);
      setTimeout(() => {
        setIsAlertOpen(false);
      }, 2000);
    }, 1000);
  };

  const handleDeleteProduct = (index) => {
    setAlertInfo({
      tituloModal: '¿Quieres eliminar este servicio?',
      textButtonAcept: 'Eliminar servicio',
      onCancel: true,
      onClose: () => setIsAlertOpen(false),
      handleAccept: () => deleteProduct(index),
      messageAlert: alertStyles(theme, OwnWarningIcon, '508px', '291px', 40, '40%'),
      showClose: false,
      isOnlyMessage: false,
    });
    setIsAlertOpen(true);
  };

  const handleSwitchChangeProduct = (event) => {
    setValueProducts('quantityToAddService', '');
    setValueProducts('isSwitchEnabled', event.target.checked);
    handleSwitchChange(event);
  };

  return (
    <>
      <Grid item xs={12} style={{ paddingLeft: '0px', paddingBottom: '32px' }}>
        <Typography align="left" className={classes.titleForm} variant="h6">
          Servicios Contratados
        </Typography>
      </Grid>
      <Container component="main" maxWidth="lg" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
        <form autoComplete="off">
          <Grid
            container
            spacing={3}
          >
            <Grid item xs={12} md={6}>
              <InputLabel />
              <CustomSelect
                label="Servicios"
                name="productService"
                options={productType}
                control={controlProducts}
                rule={Rules.required}
                required
                error={errorsProducts}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setProductType(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControlLabel
                control={(
                  <Controller
                    name="isSwitchEnabled"
                    control={controlProducts}
                    defaultValue={false}
                    render={({ field }) => (
                      <Switch
                        {...field}
                        checked={isSwitchEnabled}
                        onChange={handleSwitchChangeProduct}
                        color="primary"
                      />
                    )}
                  />
                )}
                label={(
                  <Typography noWrap style={getMulishText(500, '#575756', 14)}>
                    Cantidad ilimitada
                  </Typography>
                )}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <NumberFormatCustom
                label="Cantidad"
                name="quantityToAddService"
                control={controlProducts}
                error={(isSwitchEnabled || !canSeeErrors) ? [] : errorsProducts}
                required={!isSwitchEnabled}
                rule={isSwitchEnabled ? [] : Rules.positiveValue}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                classes={classes.typeInput}
                inputProps={{
                  maxLength: 10,
                }}
                disabled={isSwitchEnabled}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputLabel />
              <CustomSelect
                label="Tipo vigencia"
                name="validityService"
                options={listValidityTypeContracts}
                control={controlProducts}
                required
                rule={Rules.required}
                error={errorsProducts}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{ onChange: (e) => setValidityType(e) }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomInput
                label="Vigencia"
                name="validityAmount"
                control={controlProducts}
                error={errorsProducts}
                required
                rule={Rules.numerico}
                styleFromHelperText={{ style: { marginRight: 10 } }}
                inputProps={{
                  maxLength: 5,
                }}
                onValidate={(e) => {
                  if (e.target.value <= 0) {
                    setValueProducts('validityAmount', '');
                  }
                  const valueTypeValidity = getValuesProducts('validityService');
                  if (transformedListMaxValidityAmountContracts.length > 0) {
                    const valueMax = transformedListMaxValidityAmountContracts.find(
                      (maxValidity) => maxValidity.value === valueTypeValidity,
                    )?.amount;
                    if (e.target.value > valueMax) {
                      setValueProducts('validityAmount', '');
                    }
                  }
                }}
                classes={classes.typeInput}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '24px',
                marginBottom: servicesToAdd.length > 0 ? 20 : 32,
              }}
            >
              <Box className={classes.submit}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  size="medium"
                  className={classes.btnBlueSubmit}
                  onClick={handleSubmitProducts(handleAgregarProducto)}
                >
                  Crear servicio
                </Button>
              </Box>
            </Grid>
            {servicesToAdd && servicesToAdd.length > 0 ? (
              <Grid
                item
                xs={12}
                style={{ marginBottom: 32 }}
              >
                <Box style={{ minWidth: '500px' }}>
                  <TableContainer
                    component={Paper}
                    style={{
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      boxShadow: 'none',
                    }}
                    className={classes.scrollBar}
                  >
                    <Table style={{ minWidth: 300, whiteSpace: 'nowrap' }}>
                      <TableHead className={classes.tableHead}>
                        <TableRow>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ paddingLeft: 24, borderBottomLeftRadius: 10, borderBottom: 'none' }}
                          >
                            Servicio
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Cantidad
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Tipo de vigencia
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.tableCell}
                            style={{ borderBottom: 'none' }}
                          >
                            Vigencia
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableCell}
                            style={{ borderBottomRightRadius: 10, borderBottom: 'none' }}
                          />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {servicesToAdd.map((service, index) => (
                          <TableRow key={index}>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                                paddingLeft: 24,
                              }}
                            >
                              {productType.find(
                                (product) => product.value === service.productService,
                              )?.label || 'Desconocido'}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {service.isSwitchEnabled ? 'Ilimitado' : formatNumberWithCommas(service.quantityToAddService)}
                            </TableCell>
                            <TableCell
                              align="left"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {listValidityTypeContracts.find(
                                (validity) => validity.value === service.validityService,
                              )?.label || 'Desconocido'}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#575756',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              {service.validityAmount}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                color: '#333',
                                borderBottomColor: '#E5E5E5',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'end',
                                }}
                              >
                                <IconButton
                                  onClick={() => handleEditProduct(index)}
                                  style={{
                                    fontSize: '24px',
                                    color: theme.palette.primary.main,
                                  }}
                                >
                                  <EditIcon />
                                </IconButton>
                                {!service?.isExist && (
                                  <IconButton
                                    onClick={() => handleDeleteProduct(index)}
                                    style={{
                                      fontSize: '24px',
                                      marginLeft: '10px',
                                      color: theme.palette.primary.main,
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}

                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </form>
      </Container>
      <EditFirmayaServiceModify
        openClose={
          {
            isOpen: isEditing,
            close: setIsEditing,
            setAlertInfo,
            setIsAlertOpen,
          }
        }
        products={
          {
            currentProduct: productToEdit,
            listProducts: productType,
            vigencyList: listValidityTypeContracts,
            lastValidValueQuantityProducts,
            setLastValidValueQuantityProducts,
            listValidityTypeContracts,
            transformedListMaxValidityAmountContracts,
          }
        }
        styles={
          {
            typeInput: classes.typeInput,
            buttonStyles: classes.btnBlueSubmit,
            cancelButton: classes.btnSubmit,
            alertStyles,
            OwnSuccesfullIcon,
            OwnWarningIcon,
            messageStyle,
          }
        }
        modifyProduct={
          {
            currentIndex: selectedIndex,
            setServicesToAdd,
          }
        }
        formData={formData}
      />
      <AlertConfirm
        isOpen={isAlertOpen}
        tituloModal={alertInfo?.tituloModal}
        textButtonAcept={alertInfo?.textButtonAcept}
        mensajeModal={alertInfo?.mensajeModal}
        handleAccept={alertInfo?.handleAccept}
        onCancel={alertInfo?.onCancel}
        onClose={alertInfo?.onClose}
        messageAlert={alertInfo?.messageAlert}
        showClose={alertInfo?.showClose}
        isOnlyMessage={alertInfo?.isOnlyMessage}
      />
    </>
  );
};

export default FirmayaServicesEdit;
